import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
import '../../../styles/assets/css/pages/form5.css'
import { loadLocationWithMessage } from '../../../actions/location'
import { sccs_scale, sccs_questions } from '../variables/assessments/sccs.js'
import { calculateTimepoint1 } from '../../functions/timepoint.js'

import WarningIcon from '@material-ui/icons/Warning'
import Button from '@material-ui/core/Button'
import StepperSelfStigma from './stepper_self_stigma'
import { initAutosaveForForm2, ensureAutosaveInitialized, detachAutosave } from '../../utils/draftAutosaveManager'

class Sccs extends Component {
  constructor(props) {
      super(props)
      //var [fields, setFields] = useState([{ value: null }])
      this.state = {
          status: 1, // 1: no data, 2: completed, 3: past
          message: '',
          start_time: Math.floor(new Date().getTime()/1000),
          start_datetime: new Date().toLocaleString('en-US', { hour12: false }).slice(0, 19).replace('T', ' '),
          next_step: 'ismi',
          q1: -1,
          q2: -1,
          q3: -1,
          q4: -1,
          q5: -1,
          q6: -1,
          q7: -1,
          q8: -1,
          q9: -1,
          q10: -1,
          q11: -1,
          q12: -1,
          assm_status: 0,
      }
      this.answerFields = Array.from({ length: 12 }, (_, i) => `q${i+1}`)
      this._draft = null
  }

  componentDidMount() {
    this._draft = initAutosaveForForm2(this, {
       formId: `sccs`,
       fields: this.answerFields,
       expireMs: 10 * 24 * 60 * 60 * 1000,
    })
    this.getAssmProcess()
  }

  componentDidUpdate(prevProps) {
    ensureAutosaveInitialized(this, '_draft', {
       formId: `sccs:${this.props.match.params.assm_id}`,
       fields: this.answerFields,
       expireMs: 10 * 24 * 60 * 60 * 1000,
    }, prevProps)
  }

  componentWillUnmount() {
    detachAutosave(this, '_draft')
  }

  getAssmProcess = () => {
    var assm_id = this.props.match.params.assm_id
    axios({
      method: 'post',
      url: connectNode + 'admin/self_stigma/check_self_stigma_step',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid:  this.props.authReducer.uid,
        assm_id: assm_id,
      }
    })
    .then((result) => {
      var next_step = 'ismi'
      if(result['data'].length == 0) {
        axios({
          method: 'post',
          url: connectNode + 'admin/self_stigma/new_self_stigma_process',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            pid:  this.props.authReducer.uid,
            assm_id: assm_id,
          }
        })
        .then((result) => {

        })
      } else {
        if(result['data'][0].sccs_status == 1) {
          this.getCompletedData()
        } else {
          if(result['data'][0].step != 'sccs') {
            this.props.history.push('/member/assessment/self_stigma/'+result['data'][0].step+'/'+assm_id)
          }
        }
      }
    })
  }

  getCompletedData = () => {
    axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_sccs',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid:  this.props.authReducer.uid,
        assm_id: this.props.match.params.assm_id,
      }
    })
    .then((result) => {
      this.setState({
        q1: result['data'].q1,
        q2: result['data'].q2,
        q3: result['data'].q3,
        q4: result['data'].q4,
        q5: result['data'].q5,
        q6: result['data'].q6,
        q7: result['data'].q7,
        q8: result['data'].q8,
        q9: result['data'].q9,
        q10: result['data'].q10,
        q11: result['data'].q11,
        q12: result['data'].q12,
        assm_status: 1,
      })
    })
  }

  handleChange = (e) => {
    const name = e.target.name;
    const value = Number(e.target.value);
    this.setState({ [name]: value }, () => {
      if (this.state.status === 1 && this._draft) {
        this._draft.savePartial(name, value, this.state);

      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    var assm_id = this.props.match.params.assm_id
    var next_step = this.state.next_step
    if(this.state.assm_status != 1) {
      if(this.state.q1 === -1 || this.state.q2 === -1 || this.state.q3 === -1 ||
        this.state.q4 === -1 || this.state.q5 === -1 || this.state.q6 === -1 ||
        this.state.q7 === -1 || this.state.q8 === -1 || this.state.q9 === -1 ||
        this.state.q10 === -1 || this.state.q11 === -1 || this.state.q12 === -1) {
        this.setState({
          message: 'Please select all answers ',
        })
        window.scrollTo(0, 0)
      } else {
        axios({
          method: 'post',
          url: connectNode + 'patient/assessment/add_sccs',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            uid: this.props.authReducer.uid,
            user: this.state,
            assm_id: assm_id,
          }
        })
        .then((result) => {
          //console.log(result['data'])
          if(result['data'] === next_step) {
            if (this._draft) this._draft.clear()
            this.props.onLoadLocation('/member/assessment/self_stigma/'+next_step+'/'+assm_id)
            this.props.history.push('/member/assessment/self_stigma/'+next_step+'/'+assm_id)
          }
        })
      }
    } else {
      if (this._draft) this._draft.clear()
      this.props.onLoadLocation('/member/assessment/self_stigma/'+next_step+'/'+assm_id)
      this.props.history.push('/member/assessment/self_stigma/'+next_step+'/'+assm_id)
    }
  }

  render() {
    //console.log(this.state)
    return (
      <div className="assm_phq9 box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Self-Concept Clarity Scale
          </div>
          {//this.state.status == 1 &&
          <StepperSelfStigma activeStep={0} assm={'SCCS'} />}
        </div>
        { this.state.message !== '' &&
        <div className="row warning_msg6">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>
        }
        <form onSubmit={this.handleSubmit}>
        <div className="row">
          <div className="small-12 columns box1">
            <div className="row show-for-medium bold">
              <div className="medium-7 columns">&nbsp;</div>
              {sccs_scale.map(each =>
                <div className="medium-1 columns headerResize1" key={"q"+each.value}>
                  {each.label}&nbsp;
                </div>
              )}
              <div className="small-12 columns">
                <div className="sep_line1">&nbsp;</div>
              </div>
            </div>
            <div className="">
            {sccs_questions.map(eachQ =>
              <div className="row" key={"q9_"+eachQ.value}>
                <div className="small-12 medium-7 columns">
                  {eachQ.value}. {eachQ.label}
                </div>
                {sccs_scale.map(each =>
                  <div className="small-12 medium-1 columns" key={"q"+each.value}>
                    <input type="radio" name={"q"+eachQ.value} value={each.value}
                    checked={Number(this.state[`q${eachQ.value}`]) === Number(each.value)}
                    disabled={this.state.assm_status === 1}
                    onChange={(e) => this.handleChange(e)} />
                    <span className="show-for-small-only">{each.label}</span>
                  </div>
                )}
                {eachQ.value < 12 &&
                  <div className="small-12 columns">
                    <div className="sep_line3">&nbsp;</div>
                  </div>
                }
              </div>
            )}
            </div>

        </div>
        <div className="small-12 columns align_right">
          <Button variant="contained" color="primary" disableElevation
             onClick={this.handleSubmit} type="submit" className="submit_1">
              { this.state.assm_status === 1 ? 'Next' : 'Submit' }
          </Button>
        </div>
      </div>
      </form>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Sccs)
